/**
 * accessAudit.js — ส่ง log "ถ้าบังคับ perm จริง ใครจะโดนบล็อกที่หน้าไหน"
 *
 * ใช้ระหว่างช่วงทดลองของ RequirePermission ก่อนเปิดบังคับจริง
 * ปลายทางคือ console ของเซิร์ฟเวอร์ (docker logs -f pagetool_server)
 * ไม่ได้เขียนลงฐานข้อมูล เพราะเป็นของชั่วคราวที่จะถูกลบทิ้งหลังเปิดบังคับ
 *
 * ── ทำไมต้องกันส่งซ้ำ ────────────────────────────────────────────────────
 * useEffect ยิงใหม่ทุกครั้งที่ re-render และคนหนึ่งคนเปิดหน้าเดิมวันละหลายสิบ
 * รอบ ถ้าไม่กัน log จะท่วมจนอ่านไม่ออก ซึ่งเท่ากับไม่มี log
 *
 * จำเฉพาะในแท็บนี้ (module scope) — เปิดแท็บใหม่ส่งซ้ำได้ ยอมรับได้เพราะ
 * เราต้องการรู้ว่า "ใครขาดสิทธิ์อะไร" ไม่ใช่ "โดนกี่ครั้ง"
 */

const seen = new Set();

/**
 * @param {Object}   info
 * @param {string}   info.path      path จริงที่เปิด
 * @param {string}   info.pattern   pattern ที่จับคู่ได้ใน routePermissions
 * @param {string[]} info.required  key ที่ต้องมีอย่างน้อยหนึ่งตัว
 * @param {boolean}  info.enforced  ตอนนี้บล็อกจริงหรือแค่เตือน
 */
export function reportAccessDenial({ path, pattern, required, enforced }) {
  const key = `${pattern}|${(required || []).join(",")}`;
  if (seen.has(key)) return;
  seen.add(key);

  console.warn(
    `[rbac] ${enforced ? "บล็อก" : "จะโดนบล็อก"}: ${path} — ต้องมีสิทธิ์ ${(required || []).join(" หรือ ")}`,
  );

  // ส่งแบบ fire-and-forget — log ที่ส่งไม่ถึงไม่ควรทำให้หน้าเว็บสะดุด
  // cookie ต้องไปด้วยเพราะฝั่งเซิร์ฟเวอร์ต้องรู้ว่าเป็นใคร (protect)
  try {
    fetch("/api/rbac/access-audit", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path, pattern, required, enforced }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    /* ไม่ต้องทำอะไร — เป็นแค่ log */
  }
}
